import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { LeadLog } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { ArrowRight } from "lucide-react";
// import { DataTableRowActions } from "./data-table-row-actions";
// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<LeadLog>[] {
  return [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1">
            <span>{row.index + 1}</span>
            {row.original.createdAt && (
              <div>
                ( Created at -{" "}
                {format(new Date(row.original.createdAt), "PPpp")} )
              </div>
            )}
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "comments",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Name" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("comments")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },

    {
      id: "changes",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Changes" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2 items-center">
            <div className="max-w-[500px] truncate font-medium bg-red-400 px-3 py-1 text-sm rounded-md">
              {row.original?.beforeStatus}
            </div>
            <span>
              <ArrowRight className="w-4 h-4" />
            </span>
            <div className="max-w-[500px] truncate font-medium bg-emerald-400 px-3 py-1 text-sm rounded-md">
              {row.original?.afterStatus}
            </div>
          </div>
        );
      },
      enableSorting: false,
    },

    {
      accessorKey: "createdBy",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Created by" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("createdBy")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },

    // {
    //   id: "actions",
    //   cell: ({ row }) => <DataTableRowActions row={row} />,
    // },
  ];
}
